var VehicleBookingStatus;
(function (VehicleBookingStatus) {
    VehicleBookingStatus["Valid"] = "Valid";
    VehicleBookingStatus["Cancelled"] = "Cancelled";
    VehicleBookingStatus["PickedUp"] = "PickedUp";
    VehicleBookingStatus["Returned"] = "Returned";
})(VehicleBookingStatus || (VehicleBookingStatus = {}));


var PropulsionSystem;
(function (PropulsionSystem) {
    PropulsionSystem["Unknown"] = "Unknown";
    PropulsionSystem["Gazoline"] = "Gazoline";
    PropulsionSystem["Diesel"] = "Diesel";
    PropulsionSystem["LPG"] = "LPG";
    PropulsionSystem["Electric"] = "Electric";
    PropulsionSystem["HybridElectricGazoline"] = "HybridElectricGazoline";
    PropulsionSystem["HybridElectricDiesel"] = "HybridElectricDiesel";
})(PropulsionSystem || (PropulsionSystem = {}));


var UploadStatus;
(function (UploadStatus) {
    UploadStatus["Pending"] = "Pending";
    UploadStatus["Fail"] = "Fail";
    UploadStatus["Completed"] = "Completed";
})(UploadStatus || (UploadStatus = {}));